import styled from "styled-components";
import {ProfileWrapperDefaultBox} from "./profile-wrapper.default.box";

export const ProfileWrapperCasino888Box = styled(ProfileWrapperDefaultBox)`
    margin-block-end: 1rem;
`;

